import { css } from '@emotion/react';
import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';
export const linkStyle = css `
  text-align: center;
  font-family: Charlie Text, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: block;
  margin: ${wplToken('space.300')} 0;
  padding: ${wplToken('space.100')} ${wplToken('space.200')};
  color: ${getColor('b300')};
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
  }
`;
//# sourceMappingURL=show-all-link.styles.js.map